const GET_COIN_BY_ID = 'PRODUCT/GET_COIN_BY_ID';
const GET_COIN_BY_ID_SUCCESS = 'GET_COIN_BY_ID_SUCCESS';

export default {
  GET_COIN_BY_ID,
  GET_COIN_BY_ID_SUCCESS,
};
